import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';

export function MyProfileError() {
  return (
    <Alert severity="error">
      <AlertTitle>Error</AlertTitle>
      {'Cannot get show profile'}
    </Alert>
  );
}
